import { Alert, Button, Form, InputNumber, Select, Space, Switch } from "antd";
import { useEffect } from "react";
import AddIcon from "../../../../assets/icons/AddIcon";
import DeleteIcon from "../../../../assets/icons/DeleteIcon";
import GoAlertFill from "../../../../assets/icons/GoAlertFill";
import PercentageIcon from "../../../../assets/icons/PercentageIcon";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import TakaIcon from "../../../../assets/icons/TakaIcon";
import Loader from "../../../../components/ui/Loader";
import {
  useCreateOrUpdateTaxMutation,
  useGetTaxDataQuery,
  useUpdateOvertimeStatusMutation,
} from "../../../../features/payrollSetting/payrollSettingApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { selectSearchOption } from "../../../../utils/utils";
import { payrollSettingsTabList } from "./payrollSetting";

export default function TaxSetting() {
  const [form] = Form.useForm();
  const { isLoading, isError, error, data } = useGetTaxDataQuery();
  // const [isEnable, setIsEnable] = useState(false);
  const [
    createOrUpdateTax,
    {
      isLoading: isCreateLoading,
      isError: isCreateError,
      error: createError,
      isSuccess: isCreateSuccess,
    },
  ] = useCreateOrUpdateTaxMutation();
  const [
    updateOvertimeStatus,
    {
      isLoading: isStatusLoading,
      isError: isStatusError,
      error: statusError,
      isSuccess: isStatusSuccess,
    },
  ] = useUpdateOvertimeStatusMutation();

  useError(isError, error, "Get tax setting data fail");
  useError(isCreateError, createError, "Fail to update tax setting data");
  useError(isStatusError, statusError, "Fail to update status");

  const isEnable = data?.data?.is_enabled;

  const handleChangeStatus = (checked: boolean) => {
    // setIsEnable(checked);
    updateOvertimeStatus({
      component_id: data?.data?.component_id,
      is_enabled: checked,
    });
  };

  const onFinish = (values: any) => {
    const taxs = values?.taxs?.map((item: any) => ({
      ...item,
      max_salary: item?.max_salary || null,
      tax_rate: item?.tax_rate / 100,
    }));

    createOrUpdateTax({ taxs });
  };

  useEffect(() => {
    if (data?.data?.results?.length) {
      const taxs = data?.data?.results?.map((item) => ({
        id: item?.id,
        gender: item?.gender,
        min_salary: item?.min_salary || 0,
        max_salary: item?.max_salary ?? undefined,
        tax_rate: item?.tax_rate ? item?.tax_rate * 100 : 0,
      }));

      form.setFieldsValue({ taxs });
    }
  }, [data?.data?.results, form]);

  // useEffect(() => {
  //   setIsEnable(data?.data?.is_enabled ? true : false);
  // }, [data?.data?.is_enabled]);

  useEffect(() => {
    if (isCreateSuccess) {
      toast("success", "Tax setting updated successfully");
    }
  }, [isCreateSuccess]);

  useEffect(() => {
    if (isStatusSuccess) {
      toast("success", "Status updated successfully");
    }
  }, [isStatusSuccess]);

  return (
    <SidebarLayout title="Tax Setting" tabList={payrollSettingsTabList}>
      <div className={`flex items-center gap-2 my-4`}>
        <Switch
          checked={isEnable}
          onChange={handleChangeStatus}
          disabled={isStatusLoading}
        />

        <div className="text-header text-sm font-medium">
          <label className="cursor-pointer select-none">
            {isEnable ? "Enabled " : "Disabled "}
          </label>
        </div>
      </div>
      <div className={!isEnable ? "min-h-[100px]" : ""} />

      <div className={!isEnable ? "hidden" : ""}>
        <Alert
          message="Enter 0 or leave the field empty for infinite amount in max salary field"
          type="warning"
          showIcon
          icon={<GoAlertFill style={{ color: "#fff", fontSize: 20 }} />}
          className="mb-4 rounded bg-[#f59e0b] font-medium text-sm text-white !px-4 !py-2.5"
        />

        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-header text-[22px] font-semibold">
              Tax Setting
            </h3>
            <label
              htmlFor="add-unpaid-leave"
              className="outline-button-primary border flex items-center py-1.5 px-2 cursor-pointer gap-1 rounded"
            >
              <AddIcon />
              <span>Add More</span>
            </label>
          </div>

          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div>
                <Form.List initialValue={[undefined]} name="taxs">
                  {(fields, { add, remove }) => {
                    return (
                      <>
                        <button
                          className="sr-only"
                          id="add-unpaid-leave"
                          onClick={() => add()}
                          type="button"
                        >
                          Add
                        </button>
                        {fields?.map((field, index) => (
                          <div
                            className={`flex items-center justify-between pt-2 pb-2 px-3 py-1 bg-[#fbfcfd] border border-light attendance-table ${
                              index === 0 ? "border-t" : "border-t-0"
                            }`}
                            key={field.key}
                          >
                            <div className="sr-only">
                              <Form.Item
                                className="mb-0"
                                name={[index, "id"]}
                              />
                            </div>
                            <div className="flex items-center gap-2.5">
                              <span className="text-display-body text-base font-medium">
                                For
                              </span>
                              <Form.Item
                                className="mb-0"
                                name={[index, "gender"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select gender",
                                  },
                                ]}
                              >
                                <Select
                                  showSearch
                                  filterOption={selectSearchOption}
                                  placeholder="Select"
                                  options={genderList}
                                  style={{ width: 120 }}
                                  suffixIcon={<SelectDownIcon />}
                                  rootClassName="icon-gray"
                                  size="large"
                                />
                              </Form.Item>
                              <span className="text-display-body text-base font-medium">
                                From
                              </span>
                              <Form.Item
                                className="mb-0"
                                name={[index, "min_salary"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter slab",
                                  },
                                  {
                                    type: "number",
                                    min: 0,
                                    message: "From cannot be negative",
                                  },
                                  {
                                    type: "integer",
                                    message: "Amount must be an integer",
                                  },
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  style={{ width: 170 }}
                                  placeholder="-"
                                  size="large"
                                  suffix={<TakaIcon />}
                                />
                              </Form.Item>
                              <span className="text-display-body text-base font-medium">
                                to
                              </span>
                              <Form.Item
                                className="mb-0"
                                name={[index, "max_salary"]}
                                rules={[
                                  // {
                                  //   required: true,
                                  //   message: "To is required",
                                  // },
                                  {
                                    type: "number",
                                    min: 0,
                                    message: "To cannot be negative",
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (
                                        value !== undefined &&
                                        value <
                                          getFieldValue([
                                            "taxs",
                                            index,
                                            "min_salary",
                                          ])
                                      ) {
                                        return Promise.reject(
                                          new Error(
                                            "To cannot be less than From"
                                          )
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  }),
                                  {
                                    type: "integer",
                                    message: "Amount must be an integer",
                                  },
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  style={{ width: 170 }}
                                  placeholder="-"
                                  size="large"
                                  suffix={<TakaIcon />}
                                />
                              </Form.Item>
                              <span className="text-display-body text-base font-medium">
                                Tax rate is
                              </span>
                              <Form.Item
                                className="mb-0"
                                name={[index, "tax_rate"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter tax rate",
                                  },
                                  {
                                    type: "number",
                                    min: 0,
                                    message: "Tax rate cannot be negative",
                                  },
                                  {
                                    type: "number",
                                    max: 100,
                                    message: "Tax rate cannot be more than 100",
                                  },
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  style={{ maxWidth: 100 }}
                                  placeholder="-"
                                  size="large"
                                  suffix={<PercentageIcon />}
                                />
                              </Form.Item>
                            </div>
                            <Button
                              className="action-button"
                              size="small"
                              icon={<DeleteIcon />}
                              onClick={() => {
                                remove(field.name);
                              }}
                            />
                          </div>
                        ))}
                      </>
                    );
                  }}
                </Form.List>
              </div>
              <Space className="w-full pt-6 justify-end" size={12}>
                {/* <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button> */}

                {/* {isEnable && ( */}
                <Button
                  className="modal-button"
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={isCreateLoading}
                >
                  Save
                </Button>
                {/* )} */}
              </Space>
            </>
          )}
        </Form>
      </div>
    </SidebarLayout>
  );
}

const genderList = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];
